const VENUE = 'DoubleTree by Hilton Jacksonville Riverfront, 1201 Riverplace Blvd, Jacksonville, FL 32207';

const to24 = (t, mer) => {
  const [h, m] = t.split(':').map(Number);
  let hh = h % 12;
  if (mer === 'PM') hh += 12;
  return [hh, m || 0];
};

const parseTime = (str) => {
  const parts = str.split(/[–-]/).map((s) => s.trim());
  const read = (p) => { const m = p.match(/(\d{1,2}:\d{2})\s*(AM|PM)?/i); return { t: m[1], mer: m[2]?.toUpperCase() }; };
  const s = read(parts[0]);
  const e = parts[1] ? read(parts[1]) : null;
  const start = to24(s.t, s.mer || e?.mer);
  const end = e ? to24(e.t, e.mer) : [start[0] + 1, start[1]];
  return { start, end };
};

const toUtc = (date, [h, m]) => {
  const offset = date >= '2026-11-01' ? 5 : 4;
  const [y, mo, d] = date.split('-').map(Number);
  return new Date(Date.UTC(y, mo - 1, d, h + offset, m));
};

const fmt = (dt) => dt.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');

export const buildEvent = (day, item) => {
  const { start, end } = parseTime(item.time);
  return {
    title: item.title.startsWith('CBTU') ? item.title : `CBTU Region III: ${item.title}`,
    start: toUtc(day.date, start),
    end: toUtc(day.date, end),
    details: [item.room, item.note, 'CBTU Region III 2026 Regional Conference', 'https://cbturegion3.org/conference'].filter(Boolean).join('\n'),
    location: item.room ? `${item.room}, ${VENUE}` : VENUE,
  };
};

export const googleUrl = (ev) =>
  `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(ev.title)}&dates=${fmt(ev.start)}/${fmt(ev.end)}&details=${encodeURIComponent(ev.details)}&location=${encodeURIComponent(ev.location)}`;

const esc = (s) => s.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');

export const downloadIcs = (events, filename) => {
  const stamp = fmt(new Date());
  const body = events.map((ev, i) => [
    'BEGIN:VEVENT',
    `UID:cbtu-r3-${fmt(ev.start)}-${i}@cbturegion3.org`,
    `DTSTAMP:${stamp}`,
    `DTSTART:${fmt(ev.start)}`,
    `DTEND:${fmt(ev.end)}`,
    `SUMMARY:${esc(ev.title)}`,
    `DESCRIPTION:${esc(ev.details)}`,
    `LOCATION:${esc(ev.location)}`,
    'END:VEVENT',
  ].join('\r\n')).join('\r\n');
  const ics = `BEGIN:VCALENDAR\r\nVERSION:2.0\r\nPRODID:-//CBTU Region III//Conference 2026//EN\r\nCALSCALE:GREGORIAN\r\n${body}\r\nEND:VCALENDAR`;
  const url = URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
